import CityPageTemplate from "../city-template/CityPageTemplate";
import { muncieConfig } from "./data";

export default function MunciePage() {
  return <CityPageTemplate config={muncieConfig} />;
}